export const BATCH_DISMISS_DEFAULT = 500;
